export const DEBOUNCE_DELAY = 300;
